import { HttpErrorResponse } from "@angular/common/http";
import { Component, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgBsModalService } from "ng-bs-modal-service";
import { NgBsToastService } from "ng-bs-toast-service";
import { NgGenerateTableColumns } from "ng-generate-table";
import { Breadcrumb } from "../../shared/components";
import { ConfigurationsService } from "../configurations.service";
import { Version } from "./version.model";
import { RolesEnum } from "../../shared/models";
import { AuthService } from "../../core/auth";
import dayjs from "dayjs";

@Component({
    selector: "app-version",
    standalone: false,
    templateUrl: "./version.component.html",
})
export class VersionComponent {
    loading = { main: false, modal: false };
    currentVersion: Version;

    constructor(
        public authService: AuthService,
        private modalService: NgBsModalService,
        private configurationsService: ConfigurationsService,
        private toastService: NgBsToastService,
        private router: Router
    ) {}

    breadcrumb: Breadcrumb[] = [{ title: "Configurações" }];
    versions: Version[] = [];

    columns: NgGenerateTableColumns[] = [];
    ngOnInit(): void {
        this.getAll();
        this.getColumns();
    }
    isAdmin() {
        return this.authService.user.roles.includes(RolesEnum.ARIEL_ADMIN);
    }
    getColumns() {
        const adminColumns = this.isAdmin()
            ? [
                  {
                      tdClass: "td-w-auto",
                      template: () => `<button type="button" class="btn btn-sm btn-link link-success p-0"><i class="bi bi-pencil-square me-1"></i>Editar</button>`,
                      click: (rowData: Version) => this.router.navigate(["/configurations/edit", rowData.id]),
                  },
                  {
                      tdClass: "td-w-auto",
                      template: () => `<button type="button" class="btn btn-sm btn-link link-danger p-0"><i class="bi bi-trash me-1"></i>Apagar</button>`,
                      click: (rowData: Version) => this.openModal(this.deleteFooter, rowData),
                  },
              ]
            : [];

        this.columns = [
            { label: "Versão", field: "version" },
            {
                label: "Status",
                template: (rowData: Version) => (rowData.isDeprecated ? "OBSOLETA" : "ATIVA"),
            },
            {
                label: "Data de Lançamento",
                field: "createdAt",
            },
            {
                tdClass: "td-w-auto",
                template: (rawData: Version) => (!rawData.isDeprecated ? `<button type="button" class="btn btn-sm btn-link link-success p-0"><i class="bi bi-download me-1"></i>Baixar</button>` : ""),
                click: (rowData: Version) => this.downloadPlugin(rowData.version),
            },
            ...adminColumns,
        ];
    }

    downloadPlugin(version: string) {
        this.configurationsService.downloadPlugin(version).subscribe({
            next: (blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `plugin-${version}.zip`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            },
            error: (err) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, "danger"),
        });
    }

    getAll() {
        this.loading.main = true;
        this.configurationsService
            .getAll()
            .subscribe({
                next: (res) =>
                    (this.versions = res.map((data: Version) => {
                        data.createdAt = dayjs(data.createdAt).format("DD/MM/YYYY");
                        return data;
                    })),
                error: (err: HttpErrorResponse) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, "danger"),
            })
            .add(() => (this.loading.main = false));
    }

    @ViewChild("deleteFooter", { static: true }) deleteFooter: TemplateRef<any>;

    openModal(footer: TemplateRef<any>, version: Version) {
        this.currentVersion = version;
        this.modalService.open(
            {
                header: "Apagar Versão",
                body: `Você tem certeza que deseja apagar a versão <strong>${version.version}</strong>?`,
                footer,
            },
            { customClass: { modalHeader: "bg-danger text-white" } }
        );
    }

    closeModal() {
        this.modalService.close();
    }

    deleteVersion() {
        this.loading.modal = true;
        this.configurationsService
            .delete(this.currentVersion.id)
            .subscribe({
                next: () => {
                    this.toastService.send("Sucesso", `Versão ${this.currentVersion.version} apagada com sucesso`, "success");
                    this.closeModal();
                    this.getAll();
                },
                error: (err) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, "danger"),
            })
            .add(() => (this.loading.modal = false));
    }
}
